import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'availability-app-error-not-found',
  standalone: false,
  templateUrl: './availability-app-error-not-found.component.html',
  styleUrls: ['./availability-app-error-not-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvailabilityAppErrorNotFoundComponent {

}
